export const SET_PLAYLIST_DATA = 'SET_PLAYLIST_DATA';
export const SET_SESSION_INTERVAL_TIME = 'SET_SESSION_INTERVAL_TIME';
export const SET_BUFFERING = 'SET_BUFFERING';
export const SET_IS_READY = 'SET_IS_READY';
export const SET_IS_PAUSED = 'SET_IS_PAUSED';
export const SET_IS_ENDED = 'SET_IS_ENDED';
export const SET_IS_PLAYER_ERROR = 'SET_IS_PLAYER_ERROR';
